/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_AboutInputs */

const bn_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পর্কে`)
};

const de_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um`)
};

const el_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Για`)
};

const en_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const es_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fr_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const hi_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के बारे में`)
};

const hu_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körülbelül`)
};

const id_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang`)
};

const it_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di`)
};

const ja_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`について`)
};

const ko_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에 대한`)
};

const nl_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over`)
};

const pl_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O`)
};

const pt_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const ru_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О`)
};

const sv_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om`)
};

const tr_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkında`)
};

const uk_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`про`)
};

const vi_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về`)
};

const zh_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const zh_hant_action_about = /** @type {(inputs: Action_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Action_AboutInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_about = /** @type {((inputs?: Action_AboutInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_AboutInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_about(inputs)
	if (locale === "de") return de_action_about(inputs)
	if (locale === "el") return el_action_about(inputs)
	if (locale === "en") return en_action_about(inputs)
	if (locale === "es") return es_action_about(inputs)
	if (locale === "fr") return fr_action_about(inputs)
	if (locale === "hi") return hi_action_about(inputs)
	if (locale === "hu") return hu_action_about(inputs)
	if (locale === "id") return id_action_about(inputs)
	if (locale === "it") return it_action_about(inputs)
	if (locale === "ja") return ja_action_about(inputs)
	if (locale === "ko") return ko_action_about(inputs)
	if (locale === "nl") return nl_action_about(inputs)
	if (locale === "pl") return pl_action_about(inputs)
	if (locale === "pt") return pt_action_about(inputs)
	if (locale === "ru") return ru_action_about(inputs)
	if (locale === "sv") return sv_action_about(inputs)
	if (locale === "tr") return tr_action_about(inputs)
	if (locale === "uk") return uk_action_about(inputs)
	if (locale === "vi") return vi_action_about(inputs)
	if (locale === "zh") return zh_action_about(inputs)
	return zh_hant_action_about(inputs)
});